if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
} 

(function(){ 

    //shared booking
    $('.small-widget select').on('change', function() {
        var parent_id = $(this).closest('.offer-js').attr('id');
        if($('#'+parent_id+' input[name=promo_code]').length > 0) { 
            var promo_code = $('#'+parent_id+' input[name=promo_code]').val(); 
        }
        if($('#'+parent_id+' input[name=showhotel]').length > 0) { 
            var showhotel = $('#'+parent_id+' input[name=showhotel]').val(); 
        }
        var hotel_id = $('#'+parent_id+' .small-widget select').val();
        var hotel_url = 'https://www.reservhotel.com/win/owa/ibe5.main?hotel='+hotel_id;
        if(promo_code != '') hotel_url += '&PC='+promo_code; 
        if(document.location.hostname == 'www.pueblobonito.com.mx') { 
            hotel_url += '&currency=MXN&lang=2';
        } else {
            hotel_url += '&currency=USD';
        }
        //if(hotel_id == '10427') hotel_url += '&showmon=01-JAN-17';
        if(showhotel) hotel_url += '&showhotel='+showhotel;
        //$('#'+parent_id+' .small-widget .selected').html($('#'+parent_id+' .small-widget .option.active').html());
        $('#'+parent_id+' .btn').attr('href', hotel_url);
        console.log(showhotel);
    });
    $("input.specials-hotel-air").click(function() {
        if ($("input.specials-airport").is(":checked")) {
            $('input[name=showhotel]').val('N');
            $('.small-widget a.book-now').each(function(){
                this.href = this.href.replace('showhotel=Y', 'showhotel=N');
            });
        } else {
            $('input[name=showhotel]').val('Y');
            $('.small-widget a.book-now').each(function(){
                this.href = this.href.replace('showhotel=N', 'showhotel=Y');
            });
        }
    });

    function validateBooking() {
        var error = false;
        if ($('select[name=hotel]').val() === '') {
            $('#property').css('border', '1px solid red');
            error = true;
        }

        if ($('.room-air').hasClass('active')) {
            if ($('#airport2 :selected').val() == '') {
                $('#airport2').parent().css('border', '1px solid red');
                error = true;
            }
        }
        return (error) ? false : true;
    }


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //sym slider
    $('.sym-slides').slick({
        accessibility: false 
    });

    var $slickSlider = $('.slider-bg-content');
    var $slickPager = $('.slick-pager');

      $slickSlider.slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

      function updateSlickPager(slick, currentSlide) {
        var totalSlides = slick.slideCount;
        var currentDisplaySlide = currentSlide + 1;
        if(totalSlides == undefined) {
              $slickPager.text(currentDisplaySlide + '/' + '1' );
        }else {
              $slickPager.text(currentDisplaySlide + '/' + totalSlides );
        }
      
    }

    updateSlickPager($slickSlider.slick('getSlick'), 0);

    $slickSlider.on('afterChange', function(event, slick, currentSlide) {
        updateSlickPager(slick, currentSlide);
    });


	$(".gallery-block-mobile").slick({
		accessibility: true,
		slidesToShow: 1,
		slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px'
	});

    $('.sym-slides-locations').on('init', function(event, slick) {
        // $(this).append('<div class="location-progress progress-holder"><div class="slideCount"><span class="location-current"></span> / <span class="location-total"></span></div><div class="progess-svg-holder"></div></div>');
        $(this).append('<div class="location_banner"></div>');
        if(langSelected==='es')
            $('.location_banner').append('<div class="dots_title"> SELECCIONAR UBICACIÓN:</div>');
        else
            $('.location_banner').append('<div class="dots_title"> SELECT LOCATION:</div>');
        $('.location_banner').append($('.sym-slides-locations .slick-dots'));
        
        $('.location-current').text(slick.currentSlide + 1);
        $('.location-total').text(slick.slideCount);
    }).slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1, 
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: false,
        fade: true,
        customPaging : function(slider, i) {
            let title = $(slider.$slides[i]).data('title');
            return '<a class="locations-nav__page-item"> '+title+' </a>';
        }
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.location-current').text(nextSlide + 1);
    }).on('afterChange', function(event, slick, currentSlide){
        $('.location-progress .progess-svg-holder')
            .html(`<svg class="progress-svg" width="60" height="60">
            <g transform="translate(29,29)">
            <circle class="circle-go" r="28" cx="0" cy="0"></circle>
            </g>
        </svg>`);
    }).trigger('afterChange');

    $('.testimonial-slider').on('init', function(event, slick) {
        $(this).append('<div class="testimonial-progress progress-holder"><div class="slideCount"><span class="testimonial-current"></span> / <span class="testimonial-total"></span></div><div class="progess-svg-holder"></div></div>');
        $('.testimonial-current').text(slick.currentSlide + 1);
        $('.testimonial-total').text(slick.slideCount);
    }).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows:true, 
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: false,
        fade: true
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.testimonial-current').text(nextSlide + 1);
    }).on('afterChange', function(event, slick, currentSlide){
        $('.testimonial-progress .progess-svg-holder')
            .html(`<svg class="progress-svg" width="60" height="60">
            <g transform="translate(29,29)">
            <circle class="circle-go" r="28" cx="0" cy="0"></circle>
            </g> 
        </svg>`);
    }).trigger('afterChange');

    $('.specials-slider').on('init', function(event, slick) {
        $(this).append('<div class="specials-progress progress-holder"><div class="slideCount"><span class="specials-current"></span> / <span class="specials-total"></span></div><div class="progess-svg-holder"></div></div>');
        $('.specials-current').text(slick.currentSlide + 1);
        $('.specials-total').text(slick.slideCount);
    }).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows:false, 
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnHover: false,
        fade: true,
        prevArrow: '.inset-texture-background__arrow-prev',
        nextArrow: '.inset-texture-background__arrow-next'
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $('.specials-current').text(nextSlide + 1);
    }).on('afterChange', function(event, slick, currentSlide){
        $('.specials-progress .progess-svg-holder')
            .html(`<svg class="progress-svg" width="60" height="60">
            <g transform="translate(29,29)">
            <circle class="circle-go" r="28" cx="0" cy="0"></circle>
            </g> 
        </svg>`);
    }).trigger('afterChange');

    /*** fancybox ***/
    $('.fancycopy-link').fancybox({
        //baseClass : 'fancycopy-popup',
        wrapCSS : 'fancycopy-popup',
        padding: 0,
        helpers: {
            overlay: {
              locked: false
            } 
        }
    });

    function stopVideo(){
        document.getElementById("myVideoPlayer").pause();
        document.getElementById("myVideoPlayer").currentTime = 0;
   }

    //video popup
    $('.video-link').click(function(){
        $('.video-popup').fadeIn();
        document.getElementById("myVideoPlayer").play();
    });
    $('.video-popup .close-icon').click(function(){
        $('.video-popup').fadeOut();
        stopVideo();
    });

    //tabs sections
	const tabLinks = document.querySelectorAll('.js-tabs-menu a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].classList.remove('active');
			}
			this.classList.add('active');
			return false;
		}
	}

    /*** Functionality for Anchor Link '&inclusions-san-miguel' ***/

    function getUrlParameters() {
        const urlParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlParams.entries());
    
        const path = window.location.pathname;
        const hasSanMiguelDeAllende = path.includes('inclusions-san-miguel');
    
        if (hasSanMiguelDeAllende) {
            const sanMiguelTab = document.querySelector('#inclusions__tabs-menu ul li:nth-child(3)');
            if (sanMiguelTab) {
                sanMiguelTab.click();
                const inclusionsElement = document.getElementById('inclusions');
                if (inclusionsElement) {
                    inclusionsElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }
        return params;
    }
    
    document.addEventListener('DOMContentLoaded', getUrlParameters);

    // hide, show, or toggle
    const show = function (elem) {
        let getHeight = function () {
            elem.style.display = 'block';
            let height = elem.scrollHeight + 'px';
            elem.style.display = '';
            return height;
        };
        let height = getHeight(); // get element height
        elem.classList.add('appear');
        elem.style.height = height; // update the max-height
        window.setTimeout(function () {
            elem.style.height = '';
        }, 350);
    };
    const hide = function (elem) {
        elem.style.height = elem.scrollHeight + 'px';
        window.setTimeout(function () {
            elem.style.height = '0';
        }, 1);
        window.setTimeout(function () {
            elem.classList.remove('appear');
        }, 350);
    };
    const toggle = function (elem) {
        if (elem.classList.contains('appear')) {
            hide(elem);
            return;
        } else {
            show(elem);
        }
    };
    //toggle more details
    document.addEventListener('click', function (event) {
        if (!event.target.classList.contains('toggle-btn-js')) return;
        event.preventDefault();

        let content = document.querySelector(event.target.hash);
        let allcontent = document.querySelectorAll('.toggle-content');

        if (event.target.classList.contains('active')) {
            event.target.classList.remove('active');
        } else {
            event.target.classList.add('active');
        }
 
        if (!content) return;
        toggle(content);
    }, false);

    //start animations
    const intro_content = document.querySelector('.top-content-home__headline');    
	if(intro_content){
		document.getElementsByClassName('top-content-home__headline')[0].classList.add('appear');         
	}

    const intro_content_default = document.querySelector('.top-content__headline');
    if(intro_content_default){
        document.getElementsByClassName('top-content__headline')[0].classList.add('appear'); 
    }

    const booking_home = document.querySelector('.booking-widget-animation');
	if(booking_home){ 
		document.getElementsByClassName('booking-widget-animation')[0].classList.add('appear');
	}

    const interior_h1 = document.querySelector('.headline-decoration');
	if(interior_h1){ 
		document.getElementsByClassName('headline-decoration')[0].classList.add('appear');
	}

    const intro_copy = document.querySelector('.intro-copy__short-intro');
	if(intro_copy){ 
		document.getElementsByClassName('intro-copy__short-intro')[0].classList.add('appear');
	}

    const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            // window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();
    //end animations

    // toogle odd/even quad tabs module

    let filterTabSanMiguel = document.getElementById('tabs-_rhn5fm52b');
    let QuadTabSanMiguel1 = document.getElementById('quad-_7czc6ykh5');
    let QuadTabSanMiguel2 = document.getElementById('quad-_8re7v99dc');
       
    if ( filterTabSanMiguel != null) {
        filterTabSanMiguel.addEventListener('click', function() {
            let selectedTab = filterTabSanMiguel.getElementsByClassName('active')[0].dataset.ref;
    
                if (selectedTab === 'time-vantage-ballroom') {
                    QuadTabSanMiguel1.classList.add('f-reverse');
                    QuadTabSanMiguel2.classList.add('f-reverse');
                } else {
                    QuadTabSanMiguel1.classList.remove('f-reverse');
                    QuadTabSanMiguel2.classList.remove('f-reverse');
                }
        });
    }

    let bookingSelector = document.querySelector(".booking-widget .book-prop-select #property");
    let arriveInput = document.querySelector("#arrive");
    let departInput = document.querySelector("#depart");
	if (bookingSelector){

		let currentDate = new Date();
        let fixedMinDate = new Date(2025, 4, 15);

		function setMinDay(){

			if(bookingSelector.value == 10941){
				let minDate = currentDate >= fixedMinDate ? currentDate : fixedMinDate;
                //$("#arrive").datepicker("option", "minDate", "2025-07-01");
                $("#arrive").datepicker("setDate", "07/01/2025");

                let departMinDate = new Date("2025-07-05");
                $("#depart").datepicker("option", "minDate", departMinDate);
                
                // let formattedMinDate = (minDate.getMonth() + 1).toString().padStart(2, '0') + '/' + minDate.getDate().toString().padStart(2, '0') + '/' + minDate.getFullYear();
                // arriveInput.setAttribute('value', formattedMinDate);
                // let formattedMinDateDepart = (departMinDate.getMonth() + 1).toString().padStart(2, '0') + '/' + departMinDate.getDate().toString().padStart(2, '0') + '/' + departMinDate.getFullYear();
                // departInput.setAttribute('value', formattedMinDateDepart);
			}
			else{

                currentDate = new Date();

				//$("#arrive").datepicker("option", "minDate", currentDate);
                $("#arrive").datepicker("setDate", currentDate);
                let departMinDate = new Date(currentDate);
                departMinDate.setDate( currentDate.getDate() + 4 )
				// $("#depart").datepicker("option", "minDate", departMinDate);
                $("#depart").datepicker("setDate", departMinDate);

                // let formattedMinDate = (currentDate.getMonth() + 1).toString().padStart(2, '0') + '/' + currentDate.getDate().toString().padStart(2, '0') + '/' + currentDate.getFullYear();
                // arriveInput.setAttribute('value', formattedMinDate);
                // let formattedMinDateDepart = (departMinDate.getMonth() + 1).toString().padStart(2, '0') + '/' + departMinDate.getDate().toString().padStart(2, '0') + '/' + departMinDate.getFullYear();
                // departInput.setAttribute('value', formattedMinDateDepart);
			}
		}

		bookingSelector.addEventListener('change', (e)=>{
			setMinDay()
		})
		document.addEventListener('DOMContentLoaded',()=>{
			setTimeout(() => {
				setMinDay()
			}, 1000);
		})
		
	}

})();

$(function () {
    
    function scrollToTarget(selector) {
        var $target = $(selector);
        if ($target.length) {
            $('html, body').stop().animate({
                scrollTop: $target.offset().top - 120
            }, 1000);
        }
    }

    $('.page-scroll').on('click', function (event) {
        event.preventDefault();
        var href = $(this).attr('href');
        if (href.startsWith('#')) {
            scrollToTarget(href);
        } else {
            window.location.href = href;
        }
    });

    if (window.location.hash) {
        setTimeout(function () {
            scrollToTarget(window.location.hash);
        }, 500);
    }
});

/* Social Media Links Update for PB Vantage Centro Historico Mazatlan Page */

document.addEventListener('DOMContentLoaded', () => {
    const pageName = document.querySelector('.page-573724');
    if(pageName){
        const mediaFacebook = document.querySelector('.social-media li a.facebook');
        const mediaInstagram = document.querySelector('.social-media li a.instagram');
        if(mediaFacebook){
            mediaFacebook.setAttribute('href', 'https://www.facebook.com/100089674980205');
        }

        if(mediaInstagram){
            mediaInstagram.setAttribute('href', 'https://www.instagram.com/vantagepueblobonito');
        }
    }
});


/* Booking LP Widget Dates Update for SM */

function changeArriveDate(value, arrInput, depInput) {    

    if(value === '10941'){
        const newCheckInDate = '1/1/2025';
        const newCheckOutDate = '1/4/2025';

        arrInput.value = newCheckInDate;
        depInput.value = newCheckOutDate;

    } else if( page_id != 568036 ) {
        const defaultCheckInDate = '01/06/2025';
        const defaultCheckOutDate= '01/10/2025';

        arrInput.value = defaultCheckInDate;
        depInput.value = defaultCheckOutDate;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const bookingWidgetLP = document.querySelector('.booking-widget-lp');

    if(bookingWidgetLP){
        const selectedPropertyLP = bookingWidgetLP.querySelector('#property');
        const arriveInputLP = document.getElementById('arrive-lp');
        const departInputLP = document.getElementById('depart-lp');
        if(selectedPropertyLP){
            selectedPropertyLP.addEventListener('change', () => {
                // changeArriveDate(selectedPropertyLP.value, arriveInputLP, departInputLP); 
            });
        } else {
            console.log('The element with ID property was not found');
        }
    }
});

if( document.querySelector('body.page-19437'))  {
    if(document.querySelectorAll('nav.sub-menu a.js-resort-tab')) {

        let buttons = document.querySelectorAll('nav.sub-menu a.js-resort-tab');

        buttons.forEach( button => {

            button.addEventListener('click', (e) => {
                e.preventDefault()
                const tagToSearch = button.getAttribute("href");

                if(document.querySelectorAll('#resort-list .resorts-list__each-resort ')){
                    let resortsCollection = document.querySelectorAll('#resort-list .resorts-list__each-resort ');

                    resortsCollection.forEach( item => {
                        if(tagToSearch === 'all') {
                            item.classList.remove('hidden');
                        } else if( item.dataset.tag.includes(tagToSearch)) {
                            item.classList.remove('hidden');
                        } else {
                            item.classList.add('hidden');
                        }
                    })
                }

            })
        })
     }
 }